import { ReportColumn } from './types';

export interface FormattingStyles {
    row?: React.CSSProperties;
    cells: Record<string, React.CSSProperties>;
}

/**
 * Evaluates all conditional formatting rules for a given row and returns accumulated styles.
 */
export function evaluateFormatting(
    row: Record<string, any>,
    columns: ReportColumn[],
    firstRow?: Record<string, any>,
    lastRow?: Record<string, any>
): FormattingStyles {
    const result: FormattingStyles = {
        cells: {}
    };

    // Iterate through all columns that have formatting rules
    for (const col of columns) {
        if (!col.formattingConfig || col.formattingConfig.length === 0) continue;

        const val = row[col.name];
        const numValue = typeof val === 'number' ? val : Number(val);
        const isNumeric = typeof val === 'number' || (!isNaN(numValue) && val !== '' && val !== null);

        if (!isNumeric) continue;

        for (const rule of col.formattingConfig) {
            let threshold = rule.threshold;

            if (rule.comparisonType === 'first_row' && firstRow) {
                const firstVal = firstRow[col.name];
                threshold = typeof firstVal === 'number' ? firstVal : Number(firstVal);
            } else if (rule.comparisonType === 'last_row' && lastRow) {
                const lastVal = lastRow[col.name];
                threshold = typeof lastVal === 'number' ? lastVal : Number(lastVal);
            }

            if (isNaN(threshold)) continue;

            let match = false;
            switch (rule.operator) {
                case '>': match = numValue > threshold; break;
                case '>=': match = numValue >= threshold; break;
                case '<': match = numValue < threshold; break;
                case '<=': match = numValue <= threshold; break;
                case '==': match = numValue === threshold; break;
                case '!=': match = numValue !== threshold; break;
            }

            if (match) {
                const styles: React.CSSProperties = {};
                if (rule.backgroundColor) styles.backgroundColor = rule.backgroundColor;
                if (rule.textColor) styles.color = rule.textColor;

                const targets = rule.targetColumns !== undefined && rule.targetColumns !== null
                    ? rule.targetColumns
                    : [col.name];

                for (const target of targets) {
                    if (target === '__row__') {
                        result.row = { ...result.row, ...styles };
                    } else {
                        result.cells[target] = { ...result.cells[target], ...styles };
                    }
                }

                // Break after first matching rule in THIS column
                break;
            }
        }
    }

    return result;
}
